import { jsx as _jsx } from "react/jsx-runtime";
import { useMotionPresence } from '#pplx/frontend/aether/components/Motion/useMotionPresence.js';
import { SPRING_CONFIG_SNAPPY } from '#pplx/frontend/aether/config.js';
import { lazy, Suspense } from 'react';
const MotionSlideImpl = lazy(async () => {
    const { animated, useSpring } = await import('@react-spring/web');
    // Map slide direction to transform string values
    const getSlideTransforms = (slideDistancePx) => ({
        top: {
            enter: { transform: 'translateY(0px)' },
            exit: { transform: `translateY(-${slideDistancePx}px)` },
        },
        bottom: {
            enter: { transform: 'translateY(0px)' },
            exit: { transform: `translateY(${slideDistancePx}px)` },
        },
        left: {
            enter: { transform: 'translateX(0px)' },
            exit: { transform: `translateX(-${slideDistancePx}px)` },
        },
        right: {
            enter: { transform: 'translateX(0px)' },
            exit: { transform: `translateX(${slideDistancePx}px)` },
        },
    });
    function MotionSlideImpl({ isVisible, children, className, side = 'bottom', slideDistancePx = 3, }) {
        const { isPresent, animationState, isInitialEnter, handleAnimationEnd } = useMotionPresence(isVisible);
        const transforms = getSlideTransforms(slideDistancePx)[side];
        const springs = useSpring({
            to: animationState === 'exit'
                ? { ...transforms.exit, opacity: 0 }
                : { ...transforms.enter, opacity: 1 },
            from: { ...transforms.exit, opacity: 0 },
            // Skip animation on initial mount to prevent content sliding in on page load
            immediate: isInitialEnter,
            // Reset spring to 'from' position for subsequent enter animations (toggles)
            // This ensures proper slide-in animation when visibility changes from false to true
            reset: animationState === 'enter' && !isInitialEnter,
            config: { ...SPRING_CONFIG_SNAPPY, clamp: true },
            onRest: handleAnimationEnd,
        });
        if (!isPresent) {
            return null;
        }
        return (_jsx(animated.div, { style: {
                position: 'relative',
                ...springs,
            }, className: className, children: children }));
    }
    return { default: MotionSlideImpl };
});
/**
 * Slide animation component with Suspense built-in.
 * Animates in from specified direction with fade effect.
 * Supports top, bottom, left, and right directions.
 * Lazy loads react-spring only when used.
 */
export function MotionSlide(props) {
    return (_jsx(Suspense, { fallback: null, children: _jsx(MotionSlideImpl, { ...props }) }));
}
//# sourceMappingURL=MotionSlide.js.map